/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { generateCacheKey } from '@msdyn365-commerce-modules/retail-actions';
import { ICommerceApiSettings } from '@msdyn365-commerce/core';
import { ICustomerSalesRepEntity } from './DataServiceEntities.g';
import { getSalesRepInformationAsync } from './DataActionExtension.g';

/**
 * GetAllowedDays Input Action
 */
export class GetSalesRepInfoInput implements Msdyn365.IActionInput {
    public customerAccount: string;
    private readonly apiSettings: ICommerceApiSettings;
    public constructor(customerAccount: string, apiSettings: ICommerceApiSettings) {
        this.customerAccount = customerAccount;
        this.apiSettings = apiSettings;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => generateCacheKey(this.apiSettings, { key: 'customerAccount', value: this.customerAccount });
    public getCacheObjectType = () => 'ICustomerSalesRepEntity';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// TODO: Create a data model here or import one to capture the response of the action

/**
 * TODO: Use this function to create the input required to make the action call
 */
const GetSalesRepInformationInput = (args: Msdyn365.ICreateActionContext<{ customerAccount: string }>): Msdyn365.IActionInput => {
    return new GetSalesRepInfoInput(args.config?.customerAccount || '', args.requestContext.apiSettings);
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function getSalesRepInfoAsync(input: GetSalesRepInfoInput, ctx: Msdyn365.IActionContext): Promise<ICustomerSalesRepEntity> {
    const response = await getSalesRepInformationAsync({ callerContext: ctx }, input.customerAccount);
    return Promise.resolve(response);
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ICustomerSalesRepEntity>>getSalesRepInfoAsync,
    // TODO: Give your data action a unique id
    id: 'GetSalesRepInformation',
    input: GetSalesRepInformationInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
